import React, { useState } from 'react';
import { FilterIcon, ChevronDownIcon } from 'lucide-react';
export const FiltersBar = ({
  activeFilter,
  setActiveFilter
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const filters = [{
    id: 'newest',
    name: 'Newest'
  }, {
    id: 'expiring',
    name: 'Expiring soon'
  }, {
    id: 'discount',
    name: 'Highest % Off'
  }];
  return <section className="mb-6" data-id="element-69">
      <div className="flex justify-between items-center" data-id="element-70">
        <h2 className="text-lg font-bold" data-id="element-71">Popular Coupons</h2>
        <button onClick={() => setShowFilters(!showFilters)} className="flex items-center bg-white border border-gray-300 px-3 py-1 rounded-lg text-sm" data-id="element-72">
          <FilterIcon size={16} className="mr-2" data-id="element-73" />
          Filter
        </button>
      </div>
      {showFilters && <div className="mt-3 p-4 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-74">
          <div className="mb-4" data-id="element-75">
            <h3 className="text-sm font-medium mb-2" data-id="element-76">Sort by:</h3>
            <div className="flex flex-wrap gap-2" data-id="element-77">
              {filters.map(filter => <button key={filter.id} onClick={() => setActiveFilter(filter.id)} className={`px-3 py-1 text-sm rounded-full ${activeFilter === filter.id ? 'bg-blue-100 text-blue-700' : 'bg-gray-100'}`} data-id="element-78">
                  {filter.name}
                </button>)}
            </div>
          </div>
          <div className="mb-4" data-id="element-79">
            <h3 className="text-sm font-medium mb-2" data-id="element-80">Category:</h3>
            <div className="relative" data-id="element-81">
              <select className="w-full p-2 border border-gray-300 rounded-md appearance-none pr-8" data-id="element-82">
                <option data-id="element-83">All Categories</option>
                <option data-id="element-84">Groceries</option>
                <option data-id="element-85">Fashion</option>
                <option data-id="element-86">Food</option>
                <option data-id="element-87">Travel</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-3 text-gray-500" data-id="element-88" />
            </div>
          </div>
          <div data-id="element-89">
            <h3 className="text-sm font-medium mb-2" data-id="element-90">Brand:</h3>
            <div className="relative" data-id="element-91">
              <select className="w-full p-2 border border-gray-300 rounded-md appearance-none pr-8" data-id="element-92">
                <option data-id="element-93">All Brands</option>
                <option data-id="element-94">Rimi</option>
                <option data-id="element-95">Apple</option>
                <option data-id="element-96">Bolt</option>
                <option data-id="element-97">Netflix</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-3 text-gray-500" data-id="element-98" />
            </div>
          </div>
        </div>}
    </section>;
};